{
  "title": "Ayuda y soporte",
  "description": "Problemas de clientes y solicitudes de soporte",
  "tabs": {
    "customerIssues": "Problemas de clientes",
    "contact": "Obtener ayuda"
  },
  "searchPlaceholder": "Buscar...",
  "emptyTitle": "Sin problemas de clientes",
  "emptyDescription": "Los problemas reportados por clientes aparecerán aquí.",
  "contact": {
    "title": "Contactar ForumOne",
    "description": "Envíe una solicitud y nuestro equipo le responderá.",
    "categoryLabel": "Categoría",
    "categoryPlaceholder": "Seleccionar categoría",
    "subjectLabel": "Asunto",
    "subjectPlaceholder": "Resumen breve",
    "messageLabel": "Mensaje",
    "messagePlaceholder": "Describa su problema",
    "submit": "Enviar solicitud",
    "success": "Solicitud enviada",
    "error": "Error al enviar"
  },
  "columns": {
    "ticketId": "ID ticket",
    "customer": "Cliente",
    "service": "Service",
    "status": "Estado",
    "category": "Categoría"
  },
  "status": {
    "all": "Todos",
    "pending": "Pendiente",
    "inReview": "En revisión",
    "refunded": "Reembolsado",
    "rejected": "Rechazado",
    "resolved": "Resuelto",
    "cancelled": "Cancelado"
  },
  "categories": {
    "APPOINTMENT_DISPUTE": "Disputa de cita",
    "BOOKING": "Reserva",
    "PAYMENT": "Pago",
    "PAYOUT": "Pago a negocio",
    "SUBSCRIPTION": "Suscripción",
    "ACCOUNT": "Cuenta",
    "TECHNICAL": "Técnico",
    "GENERAL": "Otro"
  },
  "modal": {
    "customer": "Cliente",
    "provider": "Proveedor",
    "noProvider": "Sin proveedor",
    "noProviderEmail": "Sin correo"
  }
}
